import { Patient } from '../models/patient.model';

export const PATIENTS: Patient[] = [
  {
    id: 'p1',
    nome: 'Heloisa Aparecida Souza',
    cpf: '123.456.789-00',
    telefone: '(11) 98877-6655',
    email: 'heloisa.souza@email.com',
    iniciais: 'HS',
    queixaPrincipal: 'Dor em joelho direito e lombalgia há 8 meses',
    medicoResponsavel: 'Dr. Rafael Menezes (Ortopedista)',
    dataInicioTratamento: '2026-02-10',
    faseAtual: 'I'
  },
  {
    id: 'p2',
    nome: 'João Batista Ferreira',
    cpf: '987.654.321-00',
    telefone: '(11) 91234-5678',
    email: 'joao.ferreira@email.com',
    iniciais: 'JF',
    queixaPrincipal: 'Dor no ombro direito ao elevar o braço e irradiação para perna esquerda',
    medicoResponsavel: 'Dra. Camila Lopes (Ortopedista)',
    dataInicioTratamento: '2026-05-04',
    faseAtual: 'M'
  }
];
